import emma from '@/common/services/Emma'
import { resolveDate } from '@/common/services/ResolveDate'

const UserResource = {
	login (email, password) {
		return new Promise((resolve, reject) => {
			emma.post('api/login', {
				username: email,
				password: password
			}).then((result) => {
				if (result.data.user.roles.indexOf('ROLE_ADVISOR') === -1) reject(new Error('Mauvais login/mot de passe'))
				emma.setToken(result.data.refresh_token, result.data.token)
				this.getUser().then((user) => {
					result.data.user.firstname = user.data.user.first_name
					result.data.user.lastname = user.data.user.last_name
					result.data.user.id = user.data.user.id
					if (user.data.user.media) {
						result.data.picture = user.data.user.media.file
					}
					result.data.user.address = {
						line: user.data.user.address,
						zip: user.data.user.zipcode,
						city: user.data.user.city,
						country: user.data.user.country
					}
					result.data.user.phone = user.data.user.phone
					resolve(result.data)
				}).catch((error) => {
					reject(error)
				})
			}).catch((error) => {
				reject(error)
			})
		})
	},
	logout () { return emma.get('api/logout') },
	getUser () { return emma.get('api/profile') },
	getProspectsForDashboard() { return emma.get('api/prospects-for-dashboard')},
	getClientsForDashboard() { return emma.get('api/clients-for-dashboard')},
	getClients () { return emma.get('api/clients') },
	getClient (id) { return emma.get('api/clients/' + id) },
	addClient (client) {
		return emma.post('api/clients', {
			first_name: client.firstname,
			last_name: client.lastname,
			email: client.email,
			phone: client.phone,
			source: client.origin,
			birthdate: resolveDate(client.birthdate),
			tags: client.centerOfInterests.map(tag => tag.id),
			type: (client.type === 'Client') ? 'client_subscriber' : 'client_lead',
			address: client.address.line,
			zipcode: client.address.zip,
			city: client.address.city,
			country: client.address.country
		}, 'application/json')
	},
	editClient (client) {
		return emma.post('api/update-client', {
			user_id: client.id,
			first_name: client.firstname,
			last_name: client.lastname,
			email: client.email,
			phone: client.phone,
			source: client.origin,
			tags: client.centerOfInterests.map(tag => tag.id),
			birthdate: resolveDate(client.birthdate),
			type: (client.type === 'Client') ? 'client_subscriber' : 'client_lead',
			address: client.address.line,
			zipcode: client.address.zip,
			city: client.address.city,
			country: client.address.country
		}, 'application/json')
	},
	updateProfilePicture (data, id) {
		const request = new FormData()
		request.append('img', data)
		return emma.post('api/media/user_picture/' + id, request, 'application/x-www-form-urlencoded')
	},
	updateProfile (data) {
		const request = new FormData()
		request.append('first_name', data.firstname)
		request.append('last_name', data.lastname)
		request.append('email', data.email)
		request.append('address', data.address.line)
		request.append('zipcode', data.address.zip)
		request.append('city', data.address.city)
		request.append('country', data.address.country)
		request.append('phone', data.phone)
		return emma.post('api/profile', request)
	},
	editPassword (data) {
		return emma.post('api/change-password', data)
	},
	resetPassword (email) { return emma.post('api/resetting/request', { email: email }) },
	postLCBCFT (data) { return emma.post('api/lcbft', data, 'application/json') },
	postCheckPaysage (data) { return emma.post('api/estate/private/doc/sendmailcheckpaysage', data, 'application/json') },
	setAvailable (data) { return emma.post('api/available', data) },
	createAppointment (data) { return emma.post('api/appointments', data) },
	fetchAppointments () { return emma.get('api/appointments') },
	fetchCalendar (date) { return emma.get('api/appointments?' + (date ? 'date=' + date : 'today=true')) },
	fetchAppointmentsForClient (id) { return emma.get('api/appointments/' + id) },
	updateAppointment (id, data) { return emma.put('api/appointments/' + id, data) },
	deleteAppointment (id) { return emma.post('api/delete-appointment', { id: id }) },
	fetchMissionsForClient (id) { return emma.get('api/client-missions/' + id) },
	getCertificateLevel (id) { return emma.get('api/universign/match-account/' + id) },
	createNote (data) { return emma.post('api/note', data) },
	updateNote (id, data) { return emma.post('api/note/' + id, data) },
	deleteNote (id) { return emma.post('api/delete-note/' + id) },
	fetchNotes (id) { return emma.post('api/client-notes/' + id) },
	getInvestmentStats (userId) { return emma.get('api/investment-stats?user_id=' + userId) },
	updateInscritPartenaire (userId, value) { return emma.post('api/update-inscrit-partenaire', { user_id: userId, inscrit_partenaire: value }, 'application/json') },
	updateContractRenewal (userId) { return emma.post('api/update-contract-renewal', { user_id: userId }, 'application/json') },
	searchClients (query) { return emma.post('api/search-clients', { query: query }, 'application/json') }
}

export default UserResource



// WEBPACK FOOTER //
// ./src/resources/user.js